<template>
  <v-row align="baseline" dense>
    <slot name="label">
      <v-col cols="12" sm="6" :md="labelSize" v-if="label && !hideLabel">
        <v-card class="d-flex" flat>
          <v-card flat>
            <span :class="`subtitle-2 ${focused ? 'primary--text' : ''}`">
              {{ label }}
            </span>
            <div v-if="hint">
              <span class="text-caption">{{ hint }}</span>
            </div>
          </v-card>
        </v-card>
      </v-col>
    </slot>
    <v-col class="grow">
      <slot></slot>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "InputGeneric",
  components: {},
  mixins: [],
  props: {
    label: {
      type: String,
      required: false,
    },
    hideLabel: {
      type: Boolean,
      required: false,
      defalut: false,
    },
    hint: {
      type: String,
      required: false,
      default: null,
    },
    suffix: { type: String, required: false, default: "" },
    labelSize: {
      type: Number,
      required: false,
      default: 5,
    },
  },
  data() {
    return {
      focused: false,
    };
  },
  computed: {},
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    focus() {
      this.focused = true;
    },
    blur() {
      this.focused = false;
    },
  },
};
</script>

<style></style>
